export default __webpack_public_path__ + "static/media/0000..0004.9a864a20.png";